export const h = {
    "common": {
        "webSuffix": "Технология QIDI Tech",
        "email": "Почтовый ящик",
        "password": "Пароль",
        "verificationCode": "Код проверки",
        "username": "Имя пользователя",
        "readAndAgree": "Согласен.",
        "and": "А",
        "userAgreement": "Пользовательское соглашение",
        "privacyPolicy": "Политика конфиденциальности",
        "copy": "Все права ©  С 2025 года право собственности сохраняется.",
        "sendVerificationCode": "Отправить код проверки",
        "Sending": "Отправлено",
        "tryAgainInSeconds": "Повторная попытка через секунду.",
        "userNameRequired": "Введите имя пользователя",
        "passwordInputLabel": "Введите пароль.",
        "checkPasswordInputLabel": "Введите пароль подтверждения.",
        "userEmailRequired": "Введите адрес почтового ящика",
        "userEmailInvalid": "Введите правильный адрес почтового ящика",
        "emailCodeRequired": "Введите код проверки.",
        "newPasswordInputLabel": "Введите новый пароль.",
        "confirmPasswordInputLabel": "Введите пароль еще раз.",
        "passwordMismatchErrorLabel": "Двойной ввод пароля не совпадает",
        "agreementRequired": "Читайте и соглашайтесь с соглашением",
        "tip": "Подсказка",
        "tipAlreadyLogin": "Обнаружено, что вы вошли в систему, чтобы перейти в пользовательский центр",
        "tipWelcomeBack": "С возвращением",
        "tipDeleteAccountFail": "Ошибка удаления учетной записи, интерфейс удаления учетной записи временно закрыт",
        "pleaseAgreeFirst": "Пожалуйста, сначала согласитесь.",
        "agree": "Согласен.",
        "refuse": "Отказ",
        "tipNeedLogin": "Пожалуйста, войдите.",
        "tipChangePasswordSuccess": "Изменить пароль успешно, перейти на страницу входа",
        "tipGetUserInfoSuccess": "Получение информации успешно",
        "tipGetUserInfoFail": "Ошибка получения информации",
        "tipLoginOut": "Выход из системы",
        "delete": "Удалить",
        "back": "Возвращение",
        "init": "Инициализация",

        "passwordInputLengthErrorLabel": "Пароль должен быть от 6 до 20.",
        "changePasswordFail": "Ошибка исходного пароля",
        "tipDeleteAccountSuccess": "Удалить аккаунт успешно",
        "emailCodeSentSuccess": "Код подтверждения отправлен.",
        "emailCodeSentFail": "Ошибка отправки кода проверки",
        "emailLoginFail": "Код проверки истек.",
        "passwordLoginFail": "Ошибка пароля входа",
        "editUserInfoSuccess": "Изменение информации пользователя успешно",
        "registerSuccess": "Регистрация успешно",
        "registerFail": "Ошибка регистрации",
        "registerEmailExistFail": "Почтовый ящик уже существует.",

        "resMessageTip0": "Неизвестная информация",
        "resMessageTip1": "Ошибка пароля",
        "resMessageTip2": "Пароль должен быть от 6 до 20.",
        "resMessageTip3": "Ошибка счета",
        "resMessageTip4": "Код подтверждения отправлен.",
        "resMessageTip5": "Ошибка отправки кода проверки",
        "resMessageTip6": "Код проверки истек.",
        "resMessageTip7": "Ошибка пароля",
        "resMessageTip8": "Пароль не может быть таким же, как старый.",
        "resMessageTip9": "Почтовый ящик уже существует.",
        "resMessageTip10": "Регистрация успешно",
        "resMessageTip11": "Ошибка регистрации",
        "resMessageTip12": "Изменение информации пользователя успешно",
        "resMessageTip13": "Ошибка изменения пользовательской информации",
        "resMessageTip14": "Добиться успеха",
        "resMessageTip15": "Ошибка получения",
        "resMessageTip16": "Изменить пароль успешно",
        "resMessageTip17": "Ошибка изменения пароля",
        "resMessageTip18": "Удалить пароль",
        "resMessageTip19": "Ошибка сброса пароля",
        "resMessageTip20": "Регистрация завершена",
        "resMessageTip21": "Ошибка регистрации",
        "resMessageTip22": "Удалить аккаунт успешно",
        "resMessageTip23": "Ошибка удаления учетной записи",
        "resMessageTip24": "Ошибка в коде проверки",
        "noUserInfoError": "Ошибка сети, пожалуйста, перерегистрируйтесь"
    },
    "changePassword": {
        "newPassword": "Новый пароль"
    },
    "deleteUser": {
        "tipDeleteUser": "Жаль, что вы уезжаете. Как только ваша учетная запись будет удалена, все ваши личные данные исчезнут навсегда и не будут восстановлены.",
        "accountDeletionTerms": "Условия удаления учетной записи"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Найти пароль через почтовый ящик",
        "confirmPassword": "Подтвердить пароль",
        "resettingPassword": "Сбросить пароль",
        "resetting": "Сбросить"
    },
    "login": {
        "passwordLogin": "Пароль для входа",
        "verifyLogin": "Проверить регистрацию",
        "accountRegistration": "Регистрация счетов",
        "forgotPassword": "Забыть пароль",
        "login": "Регистрация",
        "localLogin": "Локальный вход",
        "loginOut": "Выход",
        "continueOnYourWay": "Продолжайте."
    },
    "register": {
        "registerAnAccount": "Регистрационный счет",
        "register": "Регистрация"
    },
    "userCenter": {
        "personalInformation": "Личные данные",
        "modifyInformation": "Изменить информацию",
        "changePassword": "Изменить пароль",
        "cancelAccount": "Списание счетов",
        "exitAccount": "Выйти из аккаунта",
        "change": "Изменения",
        "maxCharLimitTip": "Длина имени пользователя не должна превышать 10 букв.",
    },
    "policies": {
        "deleteAccountPrivacy": "Удалить протокол учётной записи",
        "agreement": "Использовать протокол",
        "privacyPolicy": "Политика конфиденциальности"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Выберите свою страну или регион",
        "recommendedVisits": "Рекомендуемые посещения",
        "NorthAmerica": "Северная Америка",
        "Europe": "Европа",
        "Asia": "Азия",
        "Other": "Прочее",
    }
}
export const aAndL ={
    "ar": {
        "Country": "Арабский",
        "Language": "Арабский язык"
    },
    "cs": {
        "Country": "ЧешскаяРеспублика",
        "Language": "Чешский язык"
    },
    "de": {
        "Country": "Германия",
        "Language": "Немецкий язык"
    },
    "en": {
        "Country": "Англия",
        "Language": "Английский язык"
    },
    "es": {
        "Country": "Испания",
        "Language": "Испанский язык"
    },
    "fr": {
        "Country": "Франция",
        "Language": "Французский язык"
    },
    "he": {
        "Country": "Израиль",
        "Language": "Иврит"
    },
    "hu": {
        "Country": "Венгрияworld. kgm",
        "Language": "Венгерский язык"
    },
    "it": {
        "Country": "Италия",
        "Language": "Итальянский язык"
    },
    "ja": {
        "Country": "Япония",
        "Language": "Японский язык"
    },
    "ko": {
        "Country": "Корея",
        "Language": "Корейский язык"
    },
    "nl": {
        "Country": "Нидерланды",
        "Language": "Нидерландский язык"
    },
    "pt": {
        "Country": "Португалия",
        "Language": "Португальский язык"
    },
    "pt_BR": {
        "Country": "Португалия (Бразилия)",
        "Language": "Португальский (Бразилия)"
    },
    "ru": {
        "Country": "Россия",
        "Language": "Русский язык"
    },
    "sv": {
        "Country": "Швеция",
        "Language": "Шведский язык"
    },
    "tr": {
        "Country": "Турция",
        "Language": "Турецкий язык"
    },
    "uk": {
        "Country": "Украина",
        "Language": "Украинский язык"
    },
    "zh": {
        "Country": "Континентальный Китай",
        "Language": "Упрощенный китайский"
    },
    "zh_tw": {
        "Country": "Китай",
        "Language": "Китайский стиль"
    },
    "Canada": {
        "Country": "Канада",
        "Language": "Английский язык"
    },
    "United_States": {
        "Country": "США",
        "Language": "Английский язык"
    },
    "United_Kingdom": {
        "Country": "Англия",
        "Language": "Английский язык"
    },
    "EU_Countries": {
        "Country": "Страны ЕС",
        "Language": "Английский язык"
    },
    "Australia": {
        "Country": "Австралия",
        "Language": "Английский язык"
    },
    "globalzh": {
        "Country": "Глобальный уровень",
        "Language": "Упрощенный китайский"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Английский язык"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/ru.js